var render, staticRenderFns
import script from "./TemplateHeader.vue?vue&type=script&lang=js&"
export * from "./TemplateHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d1d865')) {
      api.createRecord('70d1d865', component.options)
    } else {
      api.reload('70d1d865', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateHeader.vue"
export default component.exports